import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getUsersOwnTractors,
  IGetUsersOwnTractorsParams,
  usersOwnTractorsApiUrl,
} from '../../../../api/product/queries/getUsersOwnTractors';
import { IUserOwnTractorListItem } from '../../../../interfaces/OwnTractor.interfaces';

interface IUseGetUsersOwnTractorsQueryParams extends IGetUsersOwnTractorsParams {
  options?: UseInfiniteQueryOptions<IUserOwnTractorListItem[], AxiosError>;
}

export const useGetUsersOwnTractors = ({ searchParam, options }: IUseGetUsersOwnTractorsQueryParams) => {
  return useInfiniteQuery<IUserOwnTractorListItem[], AxiosError>(
    [
      usersOwnTractorsApiUrl,
      `machineApprovalStatus=${searchParam?.machineApprovalStatus}`,
      `isPokeEnabled=${searchParam?.isPokeEnabled}`,
      `sort=${searchParam?.sort}`,
      `minEngineOutputPs=${searchParam?.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam?.maxEngineOutputPs}`,
      `brand=${searchParam?.brand}`,
      `regionDepth1=${searchParam?.regionDepth1}`,
      `count=${searchParam?.count}`,
    ],
    ({ pageParam = 1 }) => getUsersOwnTractors({ searchParam: { ...searchParam, page: pageParam } }),
    {
      ...options,
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage?.length === 0 || lastPage?.length < searchParam.count ? undefined : nextPage;
      },
    },
  );
};
